import React from 'react';
import ReactDOM from 'react-dom';
import { Row, Col } from 'antd';
import { convertModuleByGuid } from "./SgiCompComm";
// const FormItem = Form.Item;

class SgiCol extends React.Component {

    constructor(props) {
        super(props);
        let { offset, order, span, ctlW, ctlH, style } = this.props.moduleDesc;
        this.state = {
            // style: style,
            // offset: offset,
            // order: order,
            // span: span,
            colProps: {},
            loading: false
        };
        /**
         * offset	栅格左侧的间隔格数，间隔内不可以有栅格
         * order	栅格顺序，flex 布局模式下有效
         * span	栅格占位格数，为 0 时相当于 display: none
         */
    }

    /**
   * 根据描述创建form
   * @param {父组件} parentModule 
   * @param {描述} moduleDesc       
   * @param {对象工厂} objFct 
   * @param {make类型} type 
   */
    row_mk(parentModule, moduleDesc, bdInst, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        var sonUIItems = []; //form下控件数组
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.colProps);
        //组装form表单下的控件信息
        if (type !== "dnd") this.fitSonUIItems(moduleDesc, sonUIItems, bdInst, objFct, type);

        this.sonUIItems = sonUIItems;
    }

    AddAttribute = function (moduleDesc, colProps) {
        let { offset, order, span, ctlW, ctlH, style } = moduleDesc;
        colProps.style = Object.assign({}, style);//不动描述里的style
        colProps.offset = offset;
        colProps.order = order;
        colProps.span = span;

        // style优先级高
        if (!style || style.width === undefined) {
            if (ctlW) {
                colProps.style.width = ctlW;
            } else {
                colProps.style.width = undefined;
            }
        }
        // style优先级高
        if (!style || style.height === undefined) {
            if (ctlH) {
                colProps.style.height = ctlH;
            } else {
                colProps.style.height = undefined;
            }
        }
    }

    /**
     * 根据描述组装子对象
     * @param {描述信息} moduleDesc 
     * @param {属性} formProps 
     */
    fitSonUIItems = function (moduleDesc, sonUIItems, bdInst, objFct, type) {
        var me = this;
        //form下的子节点添加到form组件中
        let cldSet = moduleDesc.cldSet;
        if (cldSet && cldSet.length && cldSet.length > 0) {
            cldSet.forEach((item, index) => {
                sonUIItems.push(convertModuleByGuid(me, item, bdInst, objFct, type));
            });

        }
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        if (!this.loaded) {
            let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性
            this.row_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }
        return (
            <Col {...this.state.colProps}>
                {this.sonUIItems}
                {this.props.children}
            </Col>
        );
    }
}

export { SgiCol };
export default SgiCol;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCol.js